export default __webpack_public_path__ + "static/media/RUNE.5adc4080.png";